<template>
  <div style="padding-top:30px">
      <div class="win" >
     <img :src="oss+data.style.icon" alt="" style="width:116px;height:116px">
    <div class="main">
       <div  :style="'color:'+data.style.color">重复查询</div>
       <p>该二维码已被查询过3次！首次查询时间 2020-06-06  首次扫码地址：广东广州天河</p>
    </div>
    <div class="buttom" >
      <div class="button" :style="'background-color:'+data.style.color">确认</div>
    </div>
  </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "win",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];

    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 440px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  padding-top: 70px;
  .main {
    text-align: center;
      position: relative;  
      border-radius: 10px;
    p{
    color: #333;
    font-size: 16px;
    width: 250px;
    margin: 0 auto;
    text-align: left;
    }
    div{
      color:#4FA1FC;
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      margin-top: 25px;
      margin-bottom: 10px;
    }
  }
  img{
    display: block;
    margin: 0 auto;
  }
  .buttom {
    width: 247.5px;
    height: 171px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding-top:90px;
    box-sizing: border-box;
    .button{
      width: 150px;
      height: 44px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin: 0 auto ;
      line-height: 44px;
      text-align: center;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #fff;
      background-color: #4FA1FC;
      border-radius: 50px;
    }
  }
}
</style>